import Vue from 'vue';
import _ from 'lodash';
import { storeCommon } from '../../store';
import {
  PRODUCT_DEFINITIONS_FETCH,
  PRODUCTS_SELECTED_ADD,
  PRODUCTS_SELECTED_ITEM_DELETE,
  PRODUCTS_SELECTED_JOB_ITEMS_ADD,
  PRODUCTS_SELECTED_SET,
  PRODUCTS_SELECTED_UNSET,
  PRODUCT_OPPORTUNITIES_FETCH,
  PRODUCT_PRESELECT_AUTOMATION,
  PRODUCT_SUPPLIERS_FETCH,
} from './types';

import { onPartialSelectionChange } from '../../utils/partial_selection';

export default {
  [PRODUCT_DEFINITIONS_FETCH](state, payload) {
    const products = payload.data.map((product) => ({
      [product.id]: {
        ...product,
        ...{ opportunity: payload.opportunity },
      },
    }));
    const serializedProducts = Object.assign({}, ...products);
    state.definitions = {
      ...state.definitions,
      ...serializedProducts,
    };
    const productDefinitions = {
      [payload.opportunity]: serializedProducts,
    };
    state.definitionsByOpportunity = {
      ...state.definitions,
      ...productDefinitions,
    };
  },
  [PRODUCTS_SELECTED_JOB_ITEMS_ADD](state, payload) {
    state.selected = {
      ...state.selected,
      ...payload,
    };
  },
  [PRODUCTS_SELECTED_ADD](state, payload) {
    let previousProducts = [];
    if (state.selected[payload.jobId]) {
      if (state.selected[payload.jobId].length > 0) {
        previousProducts = state.selected[payload.jobId];
      }
    }
    state.selected = {
      ...state.selected,
      [payload.jobId]: [...previousProducts, payload],
    };
  },
  [PRODUCTS_SELECTED_SET](state, payload) {
    const affectedProduct = state.selected[payload.jobId][payload.elementIndex];
    Vue.set(state.selected[payload.jobId], payload.elementIndex, {
      ...affectedProduct,
      ...payload,
    });
  },
  [PRODUCTS_SELECTED_ITEM_DELETE](state, payload) {
    Vue.delete(state.selected[payload.jobId], payload.elementIndex);
  },
  [PRODUCTS_SELECTED_UNSET](state, payload) {
    Vue.delete(state.selected, payload.jobId);
  },
  [PRODUCT_OPPORTUNITIES_FETCH](state, payload) {
    state.definitions[payload.productId] = {
      ...state.definitions[payload.productId],
      suppliers: _.uniq(payload.suppliers), //Array.isArray(payload.supplier) ? payload.supplier: [payload.supplier]
    };
  },
  [PRODUCT_SUPPLIERS_FETCH](state, payload) {
    state.suppliers = payload.suppliers.map((supplier) => ({
      id: supplier.id,
      name: supplier.name,
      shippingAddress: supplier.shippingAddress,
    }));
  },
  [PRODUCT_PRESELECT_AUTOMATION](state, payload) {
    const affectedProduct = state.selected[payload.jobId][payload.productIndex];
    if (!affectedProduct) {
      console.error(
        'using PRODUCT_PRESELECT_AUTOMATION with invalid payload',
        payload,
      );
      return;
    }
    const selections =
      state.selected[payload.jobId][payload.productIndex].selections;

    const updatedSelections = onPartialSelectionChange(
      selections,
      payload,
      'product',
    );
    Vue.set(
      state.selected[payload.jobId][payload.productIndex],
      'selections',
      updatedSelections,
    );
  },
};
